module.exports = __webpack_public_path__ + "static/media/my_bag.f4db41e0.svg";